<template>
  <q-dialog 
    :visible="isVisible" 
    title="修改银行卡" 
    width="500px" 
    :innerScroll="false" 
    @close="onCancel"
    @cancel="onCancel"
    @confirm="confirm"
    
  >
    <el-form :model="ruleForm" :rules="rules" ref="formRef" size="small" label-width="100px">
      <el-form-item label="提现银行卡" prop="bankAcctNo">
        <el-input v-model="ruleForm.bankAcctNo"></el-input>
      </el-form-item>
      <el-form-item label="开户行全称" prop="bankAcctName">
        <el-input v-model="ruleForm.bankAcctName"></el-input>
      </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    isShowModifyBankcard: {
      type: Boolean,
      default: false,
    },
    archivalApplyMainId: [String, Number]
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.isShowModifyBankcard;
      },
      set(val) {
        this.$emit("update:isShowModifyBankcard", val);
      },
    },
  },
  data() {
    return {
      ruleForm: {
        bankAcctName: '',
        bankAcctNo: '',
      },
      rules: {
        bankAcctNo: [
          { required: true, message: '请输入提现银行卡', trigger: 'blur' },
        ],
        bankAcctName: [
          { required: true, message: '请输入开户行全称', trigger: 'blur' },
        ],
      }
    };
  },
  methods: {
    confirm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$api.dataReport.modifyCustomerBankNo({...this.ruleForm, archivalApplyMainId: this.archivalApplyMainId})
          .then(res => {
            this.$message.success('修改成功')
            this.$emit('modifySuccess')
            this.onCancel()
          })
        } 
      });
    },
    onCancel() {
      this.$refs.formRef.resetFields();
      this.isVisible = false;
    }
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-select {
  width: 100%;
}
</style>
